"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var S = _interopRequireWildcard(require("./styled"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faInfoCircle = require("@fortawesome/pro-regular-svg-icons/faInfoCircle");

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var Checkbox = function Checkbox(props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(S.Checkbox, {
    className: "form-group"
  }, props.label && /*#__PURE__*/_react["default"].createElement("span", {
    className: "checkbox-label mb-1"
  }, props.label), /*#__PURE__*/_react["default"].createElement("input", _extends({
    type: "checkbox"
  }, props, {
    "data-testid": "label-".concat(props.label.toLowerCase().replaceAll(' ', '-'))
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "checkbox",
    "data-testid": "checkbox-".concat(props.label.toLowerCase().replaceAll(' ', '-'))
  }), props.tooltip && /*#__PURE__*/_react["default"].createElement("span", {
    "data-tooltip": props.tooltip,
    className: (0, _classnames["default"])('ml-2', {
      'tooltip-wrap': props.tooltip.length > 50
    })
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faInfoCircle.faInfoCircle
  }))), props.help && /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontSize: '12px',
      color: '#999'
    }
  }, props.help));
};

var _default = Checkbox;
exports["default"] = _default;